import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=0c52de50"
import script from "./empresa.vue?vue&type=script&lang=js"
export * from "./empresa.vue?vue&type=script&lang=js"
import style0 from "./empresa.vue?vue&type=style&index=0&id=0c52de50&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports